//  host credentials
const SSL = process.env.NODE_ENV === "production" ? "https://" : "https://";

export const HOST = process.env.NODE_ENV === "production" ? `${SSL}ven.cgseconno.in` : `${SSL}ven.cgseconno.in`;

export const UPLOAD_PRESET = "VENNINGTON";
export const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/relive-cloud/auto/upload`;
